import { colors } from "../../Styles";

export function DataParameter({size = "20px", fillColor = colors.greyLightTertiary}) {
  return (
    <svg height={size} width={size} fill={fillColor} xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 283.46 283.46">
      <path d="M87.99,87.31v-6.66c0-3.68-3.01-6.69-6.69-6.69h-4.75c-3.68,0-6.69,3.01-6.69,6.69v6.66H29.76v13.45h40.09v6.66c0,3.68,3.01,6.69,6.69,6.69h4.75c3.68,0,6.69-3.01,6.69-6.69v-6.66h165.71v-13.45H87.99Z"/>
      <path d="M206.34,128.35c0-3.68-3.01-6.69-6.69-6.69h-4.75c-3.68,0-6.69,3.01-6.69,6.69v6.66H29.76v13.45h158.45v6.66c0,3.68,3.01,6.69,6.69,6.69h4.75c3.68,0,6.69-3.01,6.69-6.69v-6.66h47.36v-13.45h-47.36v-6.66Z"/>
      <path d="M138.71,176.05c0-3.68-3.01-6.69-6.69-6.69h-4.75c-3.68,0-6.69,3.01-6.69,6.69v6.66H29.76v13.45h90.82v6.66c0,3.68,3.01,6.69,6.69,6.69h4.75c3.68,0,6.69-3.01,6.69-6.69v-6.66h114.99v-13.45h-114.99v-6.66Z"/>
    </svg>
  );
}
